import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import c from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import PopoverRootLayout from '../../layouts/PopoverRootLayout';
import { ThemeOptions, ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import PopoverHeader from '../../PopoverHeader';
import PopoverSimpleFooter from '../../PopoverSimpleFooter';
import SpreadLayout from '../../SpreadLayout';
import s from './Popover.scss';
// DS8.2 (!) comes with consts:
export const POPOVER_FOOTER_BUTTON_SIZE = 'medium';
/** Our standard popover.
 *
 * This component is not concerned with placement or show/hiding logic. That's the responsibility of the consumer.
 */ const Popover = (_param)=>{
    var { heading , subheading , headerIllustration , footerLeft , footerRight , footerMessage , footerButtonLabel , footerButtonBiData , footerButtonOnClick , className , onBackClick , onCloseClick , matchTheme =false  } = _param, rest = _object_without_properties(_param, [
        "heading",
        "subheading",
        "headerIllustration",
        "footerLeft",
        "footerRight",
        "footerMessage",
        "footerButtonLabel",
        "footerButtonBiData",
        "footerButtonOnClick",
        "className",
        "onBackClick",
        "onCloseClick",
        "matchTheme"
    ]);
    const matchThemeFlag = useFlag('popovers_match_theme');
    return /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: matchTheme || matchThemeFlag ? 'match' : ThemeOptions.LIGHT
    }, /*#__PURE__*/ React.createElement(PopoverRootLayout, _extends({
        className: c(s['root'], className),
        header: /*#__PURE__*/ React.createElement(PopoverHeader, {
            heading: heading,
            subheading: subheading,
            illustration: headerIllustration,
            onBackClick: onBackClick,
            onCloseClick: onCloseClick
        }),
        footer: footerLeft || footerRight ? /*#__PURE__*/ React.createElement(SpreadLayout, {
            left: footerLeft,
            right: footerRight
        }) : footerMessage || footerButtonLabel ? /*#__PURE__*/ React.createElement(PopoverSimpleFooter, {
            message: footerMessage,
            label: footerButtonLabel,
            biData: footerButtonBiData,
            onClick: footerButtonOnClick
        }) : undefined
    }, rest)));
};
Popover.displayName = 'Popover';
export default Popover;
